// src/cache/widgetInstance.cache.ts

import { getRedisClient } from "../../client";
import { getKey } from "../../utils/redisKeys";

const prefix = "widgetInstance";

export async function setWidgetInstance(id: string, value: any, ttlInSec?: number): Promise<void> {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  const stringified = JSON.stringify(value);

  if (ttlInSec) {
    await client.set(key, stringified, { EX: ttlInSec });
  } else {
    await client.set(key, stringified);
  }
}

export async function getWidgetInstance<T = any>(id: string): Promise<T | null> {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  const data = await client.get(key);
  return data ? JSON.parse(data) : null;
}

export async function deleteWidgetInstance(id: string): Promise<void> {
  const client = getRedisClient();
  const key = getKey({ prefix, id });
  await client.del(key);
}

export async function getWidgetInstancesBulk<T = any>(ids: string[]): Promise<(T | null)[]> {
  const client = getRedisClient();
  const keys = ids.map((id) => getKey({ prefix, id }));
  const results = await client.mGet(keys);
  return results.map((data) => (data ? JSON.parse(data) : null));
}